var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"to":"/default_home"}},[_c('i',{staticClass:"fa mr-2 fa-home text-black",attrs:{"font-scale":"1"}}),_vm._v("Home\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }